import { create } from 'zustand';
import { FEATURE_FLAGS } from '~/constants';

import { getFlagValues } from './utils';

type FlagValue = {
  value: boolean;
};
export type FlagStore = {
  flags: Record<FEATURE_FLAGS, FlagValue>;
  setFlag: (flagName: FEATURE_FLAGS, value: boolean) => void;
  setStatus: (status: FlagStore['status']) => void;
  status: 'loading' | 'error' | 'success';
  updateFlags: (flags: FEATURE_FLAGS[]) => void;
};

export const defaultFlagValues = getFlagValues([]);

export const useFlagStore = create<FlagStore>((set) => ({
  flags: defaultFlagValues,
  setStatus: (status) => set({ status }),
  setFlag: (flagName, value) => {
    set((state) => ({
      flags: {
        ...state.flags,
        [flagName]: { value },
      },
    }));
  },
  status: 'loading',
  updateFlags: (flags) => {
    const newFlags = getFlagValues(flags);
    set({ flags: newFlags });
  },
}));
